import { Input, VStack } from '@chakra-ui/react'
import Todolist from './components/todolist';

function App() {
  return (
    <div className="App" >
      <Todolist/>
    </div>
  );
}

export default App;
